import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Cli = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Cli' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,1 L23,1 L23,23 L1,23 L1,1 Z M1,5 L23,5 M5,1 L5,5 M11,16 L19,16 M5,10 L8,13 L5,16' />
  </StyledIcon>
);
